//REGISTER
export const POST_FAKE_REGISTER = "/auth/signup";

//LOGIN
export const POST_FAKE_LOGIN = "/auth/login";
export const POST_FAKE_JWT_LOGIN = "/auth/login";
export const POST_FAKE_PASSWORD_FORGET = "/auth/forgot-password";
export const POST_FAKE_JWT_PASSWORD_FORGET = "/jwt-forget-pwd";
export const SOCIAL_LOGIN = "/social-login";
export const POST_REGISTER = "/auth/registration";

//Reports
export const GET_REPORT_PROJECT = "reporting/project";

// User
export const GET_USERS = "/user/users";
export const GET_USER = "/user/users";
export const GET_USER_PROFILE = "/user/profile"
export const UPDATE_USER_PROFILE = "/user/profile"
export const ADD_NEW_USER = "/user/add";
export const UPDATE_USER = "/user/users";
export const DELETE_USER = "/user/users";
export const CHANGE_USER_PASSWORD_ADMIN = "/user/users/password-reset";
export const CHANGE_USER_PASSWORD = "/auth/password/change";

// Blocks
export const GET_BLOCKS = "/blocks";
export const GET_BLOCK_BY_ID = "/blocks";
export const ADD_NEW_BLOCK = "/blocks";
export const UPDATE_BLOCK = "/blocks";
export const DELETE_BLOCK = "/blocks";

// Clients
export const GET_CLIENTS = "/clients";
export const GET_CLIENTS_OVERDUE = "/clients/overdue_payments";
export const GET_CLIENT_BY_ID = "/clients";
export const GET_CLIENT_DETAILS = "/clients";
export const GET_AVAILABLE_CONTACTS = "/clients";
export const ADD_NEW_CLIENT = "/clients";
export const UPDATE_CLIENT = "/clients";
export const DELETE_CLIENT = "/clients";

// Contracts
export const GET_CONTRACTS = "/contracts";
export const GET_CONTRACT_BY_ID = "/contracts";
export const ADD_NEW_CONTRACT = "/contracts";
export const CREATE_CONTRACT = "/contracts";
export const UPDATE_CONTRACT = "/contracts";
export const DELETE_CONTRACT = "/contracts";

// Payments
export const GET_PAYMENTS = "/payments";
export const GET_PAYMENT_BY_ID = "/payments";
export const ADD_NEW_PAYMENT = "/payments";
export const ADD_NEW_PAYMENT_BULK = "/payments/bulk_create_percentage";
export const UPDATE_PAYMENT_BULK = "/payments/bulk_payments_update";
export const UPDATE_PAYMENT = "/payments";
export const DELETE_PAYMENT = "/payments";

// Settlement Prices
export const GET_SETTLEMENT_PRICES = "/settlement-prices";
export const GET_SETTLEMENT_PRICE_BY_ID = "/settlement-prices";
export const ADD_NEW_SETTLEMENT_PRICE = "/settlement-prices";
export const UPDATE_SETTLEMENT_PRICE = "/settlement-prices";
export const DELETE_SETTLEMENT_PRICE = "/settlement-prices";

// Units
export const GET_UNITS = "/units";
export const GET_UNIT_BY_ID = "/units";
export const GET_UNIT_BY_BLOCK = "/blocks";
export const ADD_NEW_UNIT = "/units";
export const UPDATE_UNIT = "/units";
export const DELETE_UNIT = "/units";

// Projects
export const GET_PROJECTS = "/projects";
export const GET_PROJECT_BY_ID = "/projects";
export const ADD_NEW_PROJECT = "/projects";
export const UPDATE_PROJECT = "/projects";
export const DELETE_PROJECT = "/projects";

// Phases
export const GET_PHASES = "/phases";
export const GET_PHASE_BY_ID = "/phases";
export const ADD_NEW_PHASE = "/phases";
export const UPDATE_PHASE = "/phases";
export const DELETE_PHASE = "/phases";

// PROFILE
export const POST_EDIT_JWT_PROFILE = "/post-jwt-profile";
export const POST_EDIT_PROFILE = "/user";

// Invoice
export const GET_INVOICES = "/apps/invoice";
export const ADD_NEW_INVOICE = "/apps/invoice";
export const UPDATE_INVOICE = "/apps/invoice";
export const DELETE_INVOICE = "/apps/invoice";

// Document
export const GET_DOCUMENT = "/documents";
export const UPDATE_DOCUMENT = "/documents";
export const DELETE_DOCUMENT = "/documents";
export const GET_DOWNLOAD_DOCUMENT = "/documents/{id}/download_url";

// Email
export const SEND_OVERDUE_EMAIL = "/send-overdue-emails/";
export const SEND_REMINDER_EMAIL = "/send-reminder-emails/";

export const EXTRACT_DOCUMENT = "/extract-contract";